















































import { Component, Vue } from 'vue-property-decorator';
import { app } from '@store/modules/app';
import { displayAccountType } from '@utils/investment-entity';
import { InvestmentEntity } from 'types/investment-entity';
import { user } from '@store/modules/user';

@Component
export default class NavInvestmentEntityList extends Vue {
	displayAccountType = displayAccountType;

	async changeInvestmentEntity(investmentEntityId: string) {
		try {
			await user.updateSelectedEntity(investmentEntityId);
		} catch {
			app.ADD_TOAST({
				type: 'error',
				message: 'We are unable to switch your account at this time. Please try again later.'
			});
		}
	}

	get investmentEntities(): Array<InvestmentEntity> {
		return user.user?.entityDetails.investmentEntities ?? [];
	}

	get isDesktop(): boolean {
		return app.screenSize === 'DESKTOP';
	}
}
